import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../Tooltip/Tooltip';
import InformationCircleContained from '../../Icons/InformationCircleContained';
import css from './LabelHint.module.scss';

const HINT_MAX_WIDTH = 280;

const LabelHint = ({hint}) => (
  <Tooltip content={hint} position="top" maxWidth={HINT_MAX_WIDTH} className={css.hint} portal>
    <InformationCircleContained className={css.icon} aria-hidden="true" />
  </Tooltip>
);

LabelHint.propTypes = {
  hint: PropTypes.node.isRequired,
};

export default LabelHint;
